import cn from '@pkgs/shared-client/helpers/cn';
import useFromMobileApp from '@pkgs/shared-client/hooks/useFromMobileApp';
import React from 'react';
import SVPageMargins from './SVPageMargins';

type Props = React.PropsWithChildren<{
	navigation: React.ReactNode;
}>;

const SVPageNavLayout = ({ navigation, children }: Props) => {
	const isFromMobileApp = useFromMobileApp();
	return (
		<SVPageMargins className={cn(!isFromMobileApp && 'pt-8')}>
			<div className="-sm:flex-col -sm:space-y-8 flex">
				<div className="-sm:p-0 -md:pr-8 pr-32">{navigation}</div>
				<div className="w-full flex-1">{children}</div>
			</div>
		</SVPageMargins>
	);
};

export default SVPageNavLayout;
